import { render, staticRenderFns } from "./ReceipesDetail.vue?vue&type=template&id=7cffa5e4&scoped=true&"
import script from "./ReceipesDetail.vue?vue&type=script&lang=js&"
export * from "./ReceipesDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReceipesDetail.vue?vue&type=style&index=0&id=7cffa5e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cffa5e4",
  null
  
)

export default component.exports